// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f8uG","icon":"styles_icon__2eQPb"};